export const FNO_BAN = "FNO_BAN";
export const FNO_BAN_MSG = "FNO_BAN_MSG";
export const FNO_BAN_CLEAR_MSG = "FNO_BAN_CLEAR_MSG";
export const FNO_BAN_ERROR = "FII_DII_ERROR";
export const FNO_BAN_HIDE_ERROR = "FNO_BAN_HIDE_ERROR";
export const FNO_BAN_START_LOADER = "FNO_BAN_START_LOADER";
export const FNO_BAN_STOP_LOADER = "FNO_BAN_STOP_LOADER";
